import * as React from 'react'
import Checkbox from '../Checkbox'

interface TableCheckboxProps {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled: boolean
  background?: boolean
  isHovered?: boolean
  onMouseDown?: (e: React.MouseEvent) => void
}

const TableCheckbox = ({
  checked,
  onChange,
  disabled,
  background = false,
  isHovered = false,
  onMouseDown,
}: TableCheckboxProps) => {
  return (
    <th
      onClick={(e) => e.stopPropagation()}
      onMouseDown={onMouseDown}
      className={`stickyChild notches-border--left tw-relative tw-w-4 tw-bg-white tw-pb-1.5 tw-pl-2 tw-pr-2 tw-pt-2.5 ${isHovered && 'tw-bg-white/0'} ${!background && 'lg:tw-bg-white/0'} `}
    >
      <label className={`tw-inline-flex tw-items-center`}>
        <Checkbox
          onChange={onChange}
          disabled={disabled}
          checked={checked}
          onMouseDown={onMouseDown}
        />
      </label>
    </th>
  )
}

export default TableCheckbox
